import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { contactsRouteNames, opportunitiesRouteNames } from '@/routes/constants/location'
import {requireAuthAndLocation} from '../auth'
import store from '../../store'
import { Utils } from '@/util/utils'
const SmartList = () =>
  import(/* webpackChunkName: "smartlist" */ '@/pmd/pages/smartlist/SmartList.vue').then(m => m.default)

const CustomerDetailNew = () =>
  import(/* webpackChunkName: "customer-details" */ '@/pmd/pages/customers/ContactDetailNew.vue').then(m => m.default)

const BulkActionsView = () =>
  import(/* webpackChunkName: "customer-imports" */ '@/pmd/pages/smartlist/BulkActionsView.vue').then(m => m.default)

const CustomerRestore = () =>
    import(
      /* webpackChunkName: "customer-restore" */ '@/pmd/pages/contact/RestorePage.vue'
    ).then(m => m.default)
const SmartListContainer =() =>
      import(
        /* webpackChunkName: "smartlist-container" */ '@/pmd/pages/smartlist/SmartListContainer.vue'
      ).then(m => m.default)

const BulkActionsImportPage = () => import('@/pmd/pages/bulk-actions/BulkActions.vue').then(m => m.default)

const BulkActionsContactsPage = () =>
  import(/* webpackChunkName: "customer-imports" */ '@/pmd/pages/bulk-actions/BulkActionsContactsPage.vue').then(
    m => m.default
  )

// Custom route guard to block access for the specific company ID
const blockSpecificCompany = (to, from, next) => {
  // First run the standard auth and location check
  requireAuthAndLocation(to, from, (nextRoute) => {
    // If the standard check redirects somewhere else, respect that decision
    if (nextRoute && nextRoute !== to) {
      return next(nextRoute)
    }
    
    // Get the company from the store
    const company = store.state?.company?.company
    
    // Check if the company ID matches our target ID to block
    if (Utils.isSpecialCompany()) {
      // Company ID matches, block access and redirect to dashboard
      return next({ 
        name: 'dashboard-v2',
        params: to.params,
        query: to.query,
        replace: true 
      })
    } else {
      // Company ID doesn't match, allow access
      return next()
    }
  })
}

export const contactsRoutes: RouteConfig[] = [
  {
    path: 'contacts',
    name: contactsRouteNames.default,
    component: EmptyRouterParent,
    children: [
      {
        path: 'smart_list/:smart_list',
        name: contactsRouteNames.smartList,
        component: SmartListContainer,
        beforeEnter: blockSpecificCompany,
        meta: { translations: [Modules.SmartList, Modules.ContactDetail, Modules.BulkActions] },
      },
      {
        path: 'import_filter/:import_filter',
        name: contactsRouteNames.importFilter,
        component: SmartListContainer,
        beforeEnter: blockSpecificCompany,
      },
      {
        path: 'business_name/:business_name',
        name: contactsRouteNames.businessName,
        component: SmartListContainer,
        beforeEnter: blockSpecificCompany,
      },
      {
        path: 'bulk',
        component: EmptyRouterParent,
        children: [
          {
            path: 'actions',
            name: contactsRouteNames.bulkActions,
            component: BulkActionsContactsPage,
            beforeEnter: blockSpecificCompany,
            meta: { translations: [Modules.BulkActions] },
          },
        ],
      },
      {
        path: 'detail/:contact_id',
        name: contactsRouteNames.contactDetail,
        component: CustomerDetailNew,
        beforeEnter: blockSpecificCompany,
        meta: {
          translations: [Modules.ContactDetail, Modules.SmartList, Modules.Task, Modules.Business, Modules.BulkActions],
        },
      },
      {
        path: 'restore',
        name: contactsRouteNames.contactRestore,
        component: CustomerRestore,
        beforeEnter: blockSpecificCompany,
        meta: {
          translations: [Modules.RestoreContacts, Modules.SmartList, Modules.BulkActions, Modules.ContactDetail],
        },
      },
      {
        path: 'import',
        name: contactsRouteNames.import,
        component: BulkActionsImportPage,
        beforeEnter: blockSpecificCompany,
      },
    ],
  },
]
